export default __webpack_public_path__ + "static/media/SheetMetalImg3.3d850c7b.jpg";